import * as React from "react";

import { cn } from "~/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      "flex min-h-[80px] w-full rounded-[var(--radius-xs)] border border-border-strong bg-white px-2.5 py-2 text-[14px] leading-[var(--lh-body)] text-fg-1 placeholder:text-fg-disabled focus-visible:border-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-200 disabled:cursor-not-allowed disabled:bg-bg-subtle disabled:text-fg-disabled",
      className,
    )}
    {...props}
  />
));
Textarea.displayName = "Textarea";
